exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.notifications_hide-sm__2ipZG{display:none!important}}@media (min-width:37.4rem){.notifications_visible-sm__2BKM8{display:none!important}}@media (max-width:79.9rem){.notifications_hide-md___eL7A{display:none!important}}@media (min-width:79.9rem){.notifications_visible-md__pp_fZ{display:none!important}}.notifications_container__1gCNU{display:flex;flex-direction:column;width:18.75rem}@media (max-width:37.4rem){.notifications_container__1gCNU{width:16.25rem}}.notifications_grow__3dIkf{flex-grow:1;padding-right:.625rem}.notifications_notification__2xotL{padding:.4375rem .75rem;display:flex}.notifications_title__ItsQn{font-size:.875rem;font-weight:600;padding-bottom:.0625rem}.notifications_description__1DcYx{font-size:.8125rem;color:#666}.notifications_icon__3jaRG{display:flex;align-items:center}.notifications_links__2erm-{margin-top:.625rem;font-size:.8125rem}.notifications_notificationIcon__2I-wP{width:1.625rem;height:1.625rem;line-height:1.625rem!important;text-align:center;border-radius:.125rem;font-size:.875rem;color:#fff}.notifications_textHappy__3uVq4{color:#74c0fb}.notifications_bgHappy__1a-IF{background-color:#74c0fb}.notifications_textInfo__3VQbg{color:#74c0fb}.notifications_bgInfo__1wzjH{background-color:#74c0fb}.notifications_textWarn__-4KTH{color:#fb8c00}.notifications_bgWarn__NaFUU{background-color:#fb8c00}.notifications_textError__1Lb-D{color:#db4437}.notifications_bgError__1nmGI{background-color:#db4437}", ""]);

// exports
exports.locals = {
	"hide-sm": "notifications_hide-sm__2ipZG",
	"hideSm": "notifications_hide-sm__2ipZG",
	"visible-sm": "notifications_visible-sm__2BKM8",
	"visibleSm": "notifications_visible-sm__2BKM8",
	"hide-md": "notifications_hide-md___eL7A",
	"hideMd": "notifications_hide-md___eL7A",
	"visible-md": "notifications_visible-md__pp_fZ",
	"visibleMd": "notifications_visible-md__pp_fZ",
	"container": "notifications_container__1gCNU",
	"grow": "notifications_grow__3dIkf",
	"notification": "notifications_notification__2xotL",
	"title": "notifications_title__ItsQn",
	"description": "notifications_description__1DcYx",
	"icon": "notifications_icon__3jaRG",
	"links": "notifications_links__2erm-",
	"notificationIcon": "notifications_notificationIcon__2I-wP",
	"textHappy": "notifications_textHappy__3uVq4",
	"bgHappy": "notifications_bgHappy__1a-IF",
	"textInfo": "notifications_textInfo__3VQbg",
	"bgInfo": "notifications_bgInfo__1wzjH",
	"textWarn": "notifications_textWarn__-4KTH",
	"bgWarn": "notifications_bgWarn__NaFUU",
	"textError": "notifications_textError__1Lb-D",
	"bgError": "notifications_bgError__1nmGI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Navbar/notifications.less
// module id = 1662
// module chunks = 8